// extracted by mini-css-extract-plugin
export default {"accountSelector_subtitile":"JRErui","accountSelectorSubtitile":"JRErui"};